var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousingSociety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.500244,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9583 10.0002H15.9583C15.6489 10.0002 15.3522 10.1232 15.1334 10.342C14.9146 10.5607 14.7917 10.8575 14.7917 11.1669C14.7917 11.4763 14.9146 11.7731 15.1334 11.9919C15.3522 12.2107 15.6489 12.3336 15.9583 12.3336V14.6669H11.2917C10.9822 14.6669 10.6855 14.7898 10.4667 15.0086C10.2479 15.2274 10.125 15.5242 10.125 15.8336C10.125 16.143 10.2479 16.4397 10.4667 16.6585C10.6855 16.8773 10.9822 17.0002 11.2917 17.0002V28.6669C11.2917 29.2857 11.5375 29.8792 11.9751 30.3168C12.4127 30.7544 13.0062 31.0002 13.625 31.0002H21.2083V25.1669H24.7083V31.0002H27.625C28.2438 31.0002 28.8373 30.7544 29.2749 30.3168C29.7125 29.8792 29.9583 29.2857 29.9583 28.6669V12.3336C30.2678 12.3336 30.5645 12.2107 30.7833 11.9919C31.0021 11.7731 31.125 11.4763 31.125 11.1669C31.125 10.8575 31.0021 10.5607 30.7833 10.342C30.5645 10.1232 30.2678 10.0002 29.9583 10.0002ZM15.9583 26.3336H13.625V24.0002H15.9583V26.3336ZM15.9583 21.6669H13.625V19.3336H15.9583V21.6669ZM21.7917 21.6669H19.4583V19.3336H21.7917V21.6669ZM21.7917 17.0002H19.4583V14.6669H21.7917V17.0002ZM26.4583 21.6669H24.125V19.3336H26.4583V21.6669ZM26.4583 17.0002H24.125V14.6669H26.4583V17.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingSociety);
export default __webpack_public_path__ + "static/media/housing_society.23ac95843340df8834818e0717e97a5d.svg";
export { ForwardRef as ReactComponent };